module.exports = __webpack_public_path__ + "img/page05_logo.df49e1d0.png";